import { Component, Input, OnInit } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms"
import { UserService } from "app/core/user/user.service"
import { ExtProfilesService } from "../../ext-profiles.service"
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy"

@UntilDestroy()
@Component({
    selector: 'app-internal-birthdate',
    templateUrl: './internal-birthdate.component.html',
    styleUrls: ['./internal-birthdate.component.scss'],
    standalone: false
})
export class InternalBirthdateComponent implements OnInit {

  private oldestAllowedYear = new Date().getFullYear() - 109
  private youngestAllowedYear = new Date().getFullYear() - 15

  @Input() keyname: string
  @Input() curLang: string
  @Input() displayDebug = false

  errorLabels = {
    invalidYearRange: {
      fr: `Vous devez choisir une valeur entre ${this.oldestAllowedYear} et ${this.youngestAllowedYear}`,
      en: `You must choose a value between ${this.oldestAllowedYear} and ${this.youngestAllowedYear}`
    }
  }

  /** Masqué au focus pour ne plus afficher « 0000 » tant que l’utilisateur saisit */
  yearPlaceholder = '0000'

  fGroup: UntypedFormGroup = new UntypedFormGroup({
    'keyValue': new UntypedFormControl(
      '',
      {
        validators: [
          Validators.required,
          Validators.min(this.oldestAllowedYear),
          Validators.max(this.youngestAllowedYear),
        ]
      },
    ),
  })

  constructor(
    private userService: UserService,
    private extProfilesService: ExtProfilesService
  ) {
  }

  ngOnInit(): void {
    this.fGroup.patchValue({'keyValue': this.userService.user.extProfiles[this.keyname]}, {emitEvent: false})

    this.fGroup.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
      if (this.fGroup.valid) {
        this.extProfilesService.updateExtProfiles(this.keyname, this.fGroup.get('keyValue').value)
      }
    })
  }

  onYearInputFocus(): void {
    this.yearPlaceholder = ''
  }

  onYearInputBlur(): void {
    const v = this.fGroup.get('keyValue')?.value
    if (v === '' || v === null || v === undefined) {
      this.yearPlaceholder = '0000'
    }
  }

}
